import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";

interface FileReaderProps {
  open: boolean;
  handleClose: () => void;
  fileUrl: string | undefined;
  fileName?: string
  type?: string
}

function FileReaderComponent({
  open,
  handleClose,
  fileUrl,
  fileName,
  type
}: FileReaderProps): React.JSX.Element {
  return (
    <Dialog fullScreen onClose={handleClose} open={open} sx={{ '& > div > div': { backgroundColor: '#dadada !important' } }}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            aria-label="close"
            color="inherit"
            edge="start"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <Typography>{fileName}</Typography>
        </Toolbar>
      </AppBar>
      {type === 'application/pdf' ? 
        <iframe
          height="100%"
          src={`https://docs.google.com/viewer?url=${fileUrl}&embedded=true`}
          style={{
            border: "none",
          }}
          title="file"
          width="100%"
        />
        : 
        <img src={fileUrl} style={{maxWidth: '90%', boxShadow: '0px 0px 7px #9b9b9b', margin: 'auto' }} />}
    </Dialog>
  );
}

export default FileReaderComponent;
